<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="nav-bar">
    <div class="nav-item nav-itemhover" @click="goTo('/main')">Alpha π计划</div>
    <div class="nav-item"  @click="goTo('/domp')">Viva la différence</div>
    <div class="nav-item"  @click="goTo('/domp/YeasCard')">关于阳狮</div>
  </div>
  <div class="container">
    
    <div class="box">
      <img class="topleft" src="@/assets/dlbe.png" alt="">
      <img class="bottomleft" src="@/assets/tou.png" alt="">
      <img class="bottomright" src="@/assets/ewm.png" alt="">
      <img class="btopmain" src="@/assets/title.png" alt="">
      <img class="maine" src="@/assets/titlemin.png" alt="">
      <img class="bottom" src="@/assets/ip.png" alt="">
    </div>
    <div class="header">
      <div class="con">
        <img class="conimg" src="@/assets/mainbuttonlb.png" alt="">
      </div>
      <img class="headerip" src="@/assets/ip.png" alt="">
      <div class="logo">
        <img class="logo-one" src="@/assets/aigc.png" alt="">
        <img class="logo-tow" src="@/assets/yaigc.png" alt="">
      </div>
      <div class="header-main">
        <img class="header-main-ty" src="@/assets/minty.png" alt="">
        <img class="header-main-j" src="@/assets/mainj.png" alt="">
        <img class="header-main-dd" src="@/assets/maindd.png" alt="">
        <div class="header-main-box">
          <img class="header-main-main" src="@/assets/maintop.png" alt="">
          <div class="text-list">
            <div class="list-item">AI原住民</div>
            <div class="list-item">对传播行业充满热情</div>
            <div class="list-item">硕士研究生</div>
            <div class="list-item">QS100或985、211院校背景</div>
          </div>
        </div>
        <div class="header-main-box">
          <img class="header-main-main" src="@/assets/maintow.png" alt="">
          <div class="text-list">
            <div class="list-item">Connected Media整合媒介</div>
            <div class="list-item">Intelligent Creativity智能创意</div>
            <div class="list-item">Technology 数据技术</div>
          </div>
        </div>
        <div class="header-main-box">
          <img class="header-main-main" src="@/assets/mianleft.png" alt="">
          <div class="text-list">
            <div class="list-item">高管直接辅导</div>
            <div class="list-item">真实场景、真实项目、真实成长</div>
            <div class="list-item">系统化传播行业培训</div>
            <div class="list-item">实习起薪:300元/天</div>
          </div>
        </div>
        <div class="header-main-box">
          <img class="header-main-main" src="@/assets/mainright.png" alt="">
          <div class="text-list">
            <div class="list-item">简历投递:2026年5月</div>
            <div class="list-item">面试时间:2026年6月-7月</div>
            <div class="list-item">入职时间:2026年8月</div>
            <div class="list-item">转正签约:2026年12月-2027年2月</div>
          </div>
        </div>
      </div>
      <img class="mainxt" src="@/assets/mainxt.png" alt="">
      <img class="mainxxt" src="@/assets/mainxxt.png" alt="">
      <div class="header-sss">
        <img class="header-sss-j" src="@/assets/mainj.png" alt="">
        <img class="header-sss-jr" src="@/assets/mainj.png" alt="">
        <img class="header-sss-je" src="@/assets/minty.png" alt="">
        <img class="header-sss-jd" src="@/assets/maindl.png" alt="">
        <div class="sss-item">
          <img class="sss-img" src="@/assets/mainda.png" alt="">
          <div class="sss-text">
            <p>作为阳狮专业团队的一员，你将深度参与头部项目，与标杆品牌共创商业实践。<span style="color:#ff4d4f;">依托阳狮庞大的用户数据资产与前沿AI能力</span>，我们能够从用户洞察出发，识别真实需求、理解行为逻辑，并将数据转化为可落地的传播与增长策略。你的创意、分析或决策，将不只是表达观点，而将有可能直接在市场头部品牌项目中落地。</p>
          </div>
        </div>
        <div class="sss-item">
          <img class="sss-img" src="@/assets/maindb.png" alt="">
          <div class="sss-text">
            <p><span style="color:#ff4d4f;">我们不是把AI当作工具</span>，而是将其构建为工作的底层能力。过去十年，<span style="color:#ff4d4f;">阳狮在数据、技术与AI领域累计投入超140亿欧元</span>，形成覆盖全球、可真实应用的技术与数据体系。</p>
            <p><span style="color:#ff4d4f;">在这里，AI不只加成某个环节，而是贯穿每天的工作</span>——从创意、内容到策略，你将与AI持续协同，让创意更高效、判断更有依据、策略更可落地。通过系统化培训、跨团队跨市场的Al大赛与真实项目实践，你将在“学习一试验一实战”的循环中不断进阶，全面提升创意表达、技术应用与决策判断力。</p>
          </div>
        </div>
        <div class="sss-item">
          <img class="sss-img" src="@/assets/maindc.png" alt="">
          <div class="sss-text">
            <p>在“一个阳狮”框架下，你将与媒介、创意、技术等专业团队协同工作，接触多元方法论，快速拓宽职业路径，建立跨职能的系统能力。同时，阳狮集团业务覆盖全球100多个国家与地区。<span style="color:#ff4d4f;">你将有机会参与跨国项目、与海外团队协同，在多元文化环境中拓展全球化职业视野</span>。</p>
          </div>
        </div>
        <img class="sss-button" @click="goMain" src="@/assets/mainbutton.png" alt="">
      </div>
    </div>
  </div>

</template>

<script setup>
import { useRouter } from 'vue-router'
const router = useRouter()

const goMain = () => {
   window.open('https://app.mokahr.com/m/social-recruitment/publicis/164151?hash=%23%2Fjob%2F7a128140-114c-46ce-aeed-25b9b66d892c%3Ffrom%3Dqrcode', '_blank')
}

const goTo = (path) => {
  
  router.push(path)
  window.scrollTo(0, 0)
}
</script>

<style scoped>
.nav-bar {
 
  width: 100%;
  height: 60px;
  background: #F87373;
  
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 60px;
  z-index: 9999;
}

.nav-item {
  cursor: pointer;
  font-size: 16px;
  color: #333;
  transition: color 0.3s ease;
  font-family: 'Noto Sans SC', sans-serif;
  font-weight: 350;
}

.nav-itemhover {
  color: #fff;
}

* {
  box-sizing: border-box;
}
html, body {
  overflow-x: hidden;
}
.container {
  max-width: 100vw;
  overflow-x: hidden;
}
.container { 
  width: 100%;
  margin: 0;
  padding: 0;
  position: relative;
}
.con{
position: absolute;
    bottom: 0px;
    left: 50%;
    transform: translateX(-50%);
    width: 1420px;
    height: auto;
}
  .conimg{
    width: 1350px
  }
.box {
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  position: relative;
}

img {
  display: block;
  height: auto;
}

.topleft {  
  position: absolute;
  left: 0;
  top: 0;
  width: 15%;
}

.bottomleft {
  position: absolute;
  left: 3%;
  bottom: 0;
  width: 30%;
}

.bottomright {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 28%;
}

.btopmain {
  position: absolute;
  top: 9%;
  left: 50%;
  transform: translateX(-50%);
  width: 60%;
  height: auto;
}

.maine {
  position: absolute;
  top: 55%;
  left: 53%;
  transform: translate(-50%, -50%);
  width: 25%;
}

.bottom {
  display: block;
  position: absolute;
  top: 87%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 27%;
}

.header {
  width: 1420px;
  margin: 0 auto;
  position: relative;
}

.logo {
  width: 1420px;
  margin: 0 auto;
}

.logo img {
  width: 1420px;
  height: 0 auto;
  margin-top: 40px;
}

.header-main {
  position: relative;
  width: 1000px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 40px;
}

.header-main-box {
  width: 37%;
  height: auto;
  padding: 5px;
  margin-top: 10px;
}
.header-main-box > img {
  height: 70px;
}

.header-sss {
  width: 1000px;
  margin: 0 auto;
  padding: 20px 0;
  position: relative;
}
 .header-sss-j{
    position: absolute;
    right: 60px;
    top: 46%;
    width: 13px;
  }
.header-main-ty {
  position: absolute;
  right: -25px;
  top: 50%;
  width: 7px;
  height: auto;
}

.header-main-dd {
  position: absolute;
  right: -10%;
  top: 0%;
  width: 90px;
  height: auto;
}

.header-main-j {
  position: absolute;
  left: -40px;
  top: 42%;
  width: 10px;
  height: auto;
}

.text-list {
  margin-top: 30px;
  margin-bottom: 20px;
  font-family: 'Noto Sans SC', sans-serif;
  font-weight: 400;
}
.list-item {
  display: flex;
  align-items: flex-start;
  font-size: 22px;
  color: #4d4d4d;
  margin: 10px 0;
  font-family: 'Noto Sans SC', sans-serif;
  font-weight: 400;
}
.list-item::before {
  content: '';
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: #ff4d4f;
  margin-right: 12px;
  margin-top: 15px;
}
.logo-one{
  display: block;
}
.logo-tow{
  display: none;
}
.headerip{
  display: none;
}
.mainxt{
  display: block;
  width: 1000px;
  margin: 0 auto;
  margin-bottom: 20px;
}
.mainxxt{
  display: none;
  margin: 0 auto;
}

/* 👇 新增的 header-sss 样式 */
.sss-item {
  margin-bottom: 40px;
}
.sss-img {
  height: 70px;
  margin-bottom: 10px;
}
.sss-text{
  width: 85%;
}
.sss-text p {
  font-size: 19px;
  line-height: 1.8;
  color: #333;
  margin: 10px 0;
  text-align: justify;
  font-family: 'Noto Sans SC', sans-serif;
  font-weight: 350;
  text-align: justify;
    line-break: strict;
    word-break: break-all;
}

.sss-text p span {
  font-weight: 700;
}
.header-sss-jr{
    display: none;
  }
  .header-sss-je{
    display: none;
  }
  .header-sss-jd{
    display: none;
  }
  .sss-button{
    margin: 50px auto 120px auto;
    width: 300px; 
    z-index: 999;
     transition: all 0.2s ease;
     cursor: pointer;
  }
  .sss-button:active {
  transform: scale(0.9); /* 缩小一点点 */
  opacity: 0.9; /* 微微变暗 */
}

  .sss-text .bra {
  display: none;
}
.sss-text .bre {
  display: block;
}

@media (max-width: 768px) {
  .nav-bar {
    height: 50px;
    gap: 15px;
    padding: 0 10px;
  }
  
  .nav-item {
    font-size: 12px;
  }
  
  .mainxt{
    display: none;
  }
  .mainxxt{
    display: block;
    width: 60%;
  }
  .headerip{
    display: block;
    margin: auto;
    width: 30%;
    margin-top: 20px;
  }
  .logo-one{
    display: none;
  }
  .logo-tow{
    display: block;
  }
  .box {
    width: 100%;
    height: 200px;
    /* margin-top: 50px; */
  }

  .btopmain {
    width: 60%;
    height: auto;
  }
 .logo{
  width: 100%
 }
  .logo>img {
    margin-top: 20px;
    width: 100%;
  }

  .bottom {
    display: none;
  }

  .maine {
    top: 80%;
  }

  .header-main {
    width: 80%;
    height: auto;
    margin-top: 20px;
  }
  .text-list{
    margin-top: 15px;
  }
  .header-main-dd {
    position: absolute;
    right: -40px;
    top: 0%;
    width: 35px;
    height: auto;
  }

  .header-main-j {
    position: absolute;
    left: -20px;
    top: 80px;
    width: 6px;
    height: auto;
  }

  .header-main-ty {
    position: absolute;
    right: -20px;
    top: 90px;
    width: 4px;
    height: auto;
  }

  .header-sss {
    width: 68%;
    height: auto;
    padding: 10px 0;
    margin-top: 30px;
    position: relative;
  }
  .header-sss-j{
    position: absolute;
    right: -20px;
    top: 70%;
    width:5px;
  }
  .header-sss-jr{
    display: block;
    position: absolute;
    right: -20px;
    top: 30%;
    width:5px;
  }
  .header-sss-je{
    display: block;
    position: absolute;
    left: -30px;
    top: -11%;
    width:10px;
  }
  .header-sss-jd{
    display: block;
    position: absolute;
    right: -57px;
    top: 10px;
    width:55px;
  }
  .header-sss-dlb{
    display: block;
    position: absolute;
    left: -30px;
    top: -11%;
    width:10px;
  }
  .list-item {
    font-size: 14px;
  }
  .list-item::before {
    width: 4px;
    height: 4px;
    margin-right: 8px;
    margin-top: 9px;
  }
  .header-main{
    flex-direction: column;
  }
  .header-main-box {
    width: 80%;
    height: auto;
    padding: 5px;
    margin-top: 10px;
  }
  .header-main-box > img {
    height: 40px;
  }
  .list-item{
    margin: 6px 0;
  }

  /* 移动端适配 */
  .sss-img {
    height: 40px;
  }
  .sss-text{
  width: 100%;
}
  .sss-text p {
    font-size: 13px;
  }
  .sss-button{
    margin: 50px auto 70px auto;
    width: 165px; 
  }
  .sss-text p{
    line-height: 1.6;
  }
  .sss-text .bra {
    display: block;
  }
  .sss-text .bre {
  display: none;
}
.header {
  width: 375px;
  margin: 0 auto;
  position: relative;
}
.conimg{
  position: absolute;
  bottom: 0px;
  left: 0px;
  width: 100%;
  height: auto;
}
.con{
  width: 100%;
}
}
.nav-item.active {
  color: #fff;
}
</style>